import {
  Box,
  Grid,
  Typography,
  Paper,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const statsLeft = [
  { value: "3M+", label: "Satisfied Customers", border: true },
  { value: "3", label: "Kulche Shulche Locations" },
  { value: "20+", label: "Majedar Dishes", border: true },
  { value: "2+", label: "Years of Experience" },
];

const StatsSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, sm: 4 },
        backgroundColor: "#fff",
      }}
    >
      <Grid
        container
        spacing={isMobile ? 4 : 6}
        alignItems="center"
        justifyContent="center"
        direction={isMobile ? "column-reverse" : "row"}
      >
        {/* Left Side Stats Grid */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={3} sx={{ justifyContent: "space-around" }}>
            {statsLeft.map((stat, index) => (
              <Grid item xs={6} key={index}>
                <Box height="100%">
                  <Paper
                    elevation={stat.border ? 1 : 0}
                    sx={{
                      p: isMobile ? 2 : 3,
                      border: stat.border ? "1px solid #F57C00" : "none",
                      borderRadius: 2,
                      textAlign: "center",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        color: "#F57C00",
                        fontWeight: 700,
                        fontSize: isMobile ? "1.2rem" : "1.5rem",
                      }}
                    >
                      {stat.value}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        fontWeight: 500,
                        color: "#555",
                        fontSize: isMobile ? "0.85rem" : "1rem",
                      }}
                    >
                      {stat.label}
                    </Typography>
                  </Paper>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Right Side Main Stat */}
        <Grid item xs={12} md={6} textAlign="center">
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              color: "#F57C00",
              fontSize: { xs: "3rem", sm: "3.5rem", md: "5rem" },
              lineHeight: 1.1,
            }}
          >
            11M+
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              color: "#666",
              mt: { xs: 0, md: -1 },
              fontSize: { xs: "1rem", sm: "1.2rem", md: "1.5rem" },
            }}
          >
            KULCHE'S <br />
            SOLD
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StatsSection;
